import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchTemples } from "../redux/templeSlice";
import { getTempleImageUrl } from "../utils/imageHelper";

import SectionTitle from "../components/SectionTitle";
import BannerSlider from "../components/BannerSlider";
import DevoteeQuotesSlider from "../components/DevoteeQuotesSlider";

import "../App.css";

/* ── Styled placeholder for temples without real photos ── */
const ImagePlaceholder = ({ name, height = "180px" }) => (
  <div
    style={{
      width: "100%",
      height,
      background: "linear-gradient(135deg, #f5f0e8 0%, #e8ddd0 100%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#8b7355",
      fontSize: "14px",
      fontWeight: "500",
      borderBottom: "1px solid #e0d5c5"
    }}
  >
    <span style={{ fontSize: "32px", marginBottom: "6px" }}>🛕</span>
    <span>{name || "Image Coming Soon"}</span>
  </div>
);

function Home() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { temples } = useSelector(state => state.temples);

  /* ---------------- FETCH TEMPLES ---------------- */

  useEffect(() => {
    dispatch(fetchTemples());
  }, [dispatch]);

  /* ---------------- NAVIGATE WITH CATEGORY ---------------- */

  const openCategory = (category) => {

    navigate("/temples", {
      state: { category }
    });

  };

  return (

    <div className="home-bg">

      {/* -------- Banner -------- */}

      <BannerSlider temples={temples} />

      <div className="container mt-4">


        {/* -------- Temple Cards -------- */}

        <SectionTitle title="Temples" />

        <div className="row">

          {temples.slice(0, 8).map(t => {
            const imgUrl = getTempleImageUrl(t.image);
            return (
              <div className="col-md-3 mb-3" key={t._id}>

                <div className="card shadow h-100">

                  {imgUrl ? (
                    <img
                      src={imgUrl}
                      alt={t.name}
                      className="card-img-top"
                      style={{ height: "180px", objectFit: "cover" }}
                    />
                  ) : (
                    <ImagePlaceholder name={t.name} height="180px" />
                  )}

                  <div className="card-body">

                    <h5>{t.name}</h5>
                    <p className="text-muted">{t.location}</p>

                  </div>

                  <Link
                    to={`/temple/${t._id}`}
                    className="custom-link-btn"
                  >
                    View Details
                  </Link>

                </div>

              </div>
            );
          })}

        </div>

        <Link to="/temples" className="custom-link-btn">
          Explore More
        </Link>
        <hr></hr>

        {/* -------- Gallery Section -------- */}

        <SectionTitle title="Photos & Videos" />

        <div className="row">

          {temples.slice(0, 4).map(t => {
            const imgUrl = getTempleImageUrl(t.image);
            return (
              <div className="col-md-3 col-sm-6 mb-3" key={t._id}>

                <div className="card shadow h-100">

                  {imgUrl ? (
                    <img
                      src={imgUrl}
                      alt={t.name}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover"
                      }}
                    />
                  ) : (
                    <ImagePlaceholder name={t.name} height="200px" />
                  )}

                </div>

              </div>
            );
          })}

        </div>

        <Link to="/gallery" className="custom-link-btn">
          Explore Gallery
        </Link>
        <hr></hr>

        {/* -------- Devotee Quotes -------- */}

        <SectionTitle title="Loved by Devotees" />

        <DevoteeQuotesSlider />
        <hr></hr>

        {/* -------- Explore by Religion -------- */}

        <SectionTitle title="Explore Places by Religion" />

        <div className="row text-center" style={{ border: '0px solid black', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>

          {["Hindu Temple", "Buddha Stupa", "Jain Temple", "Gurudwara"].map(cat => (

            <div className="col-md-2 mb-2" key={cat}>

              <button
                className="btn btn-outline-primary w-100 shadow"
                onClick={() => openCategory(cat)}
              >
                {cat}
              </button>

            </div>

          ))}

        </div>
        <hr></hr>

        {/* -------- Famous Temples -------- */}

        <SectionTitle title="Most Famous Places" />

        <div className="row">

          {temples.slice(0, 6).map(t => {
            const imgUrl = getTempleImageUrl(t.image);
            return (
              <div className="col-md-2" key={t._id}>

                <div className="card shadow h-100">

                  {imgUrl ? (
                    <img
                      src={imgUrl}
                      alt={t.name}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover"
                      }}
                    />
                  ) : (
                    <ImagePlaceholder name={t.name} height="200px" />
                  )}

                  <div className="card-body text-center">
                    <h6 className="fw-bold">{t.name}</h6>
                  </div>

                </div>

              </div>
            );
          })}

        </div>

        <Link to="/temples" className="custom-link-btn">
          Explore More
        </Link>
        <hr></hr>

      </div>

    </div>

  );

}

export default Home;